import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import '../theme/index.css'
import './assets/css/icon.css';
import './common/directives';
import 'babel-polyfill';
import vcolorpicker from 'vue-color'
import echarts from 'echarts'
import $ from 'jquery'
import VueClipBoard from 'vue-clipboard2'
import {getUserInfo} from "./utils/user";
Vue.prototype.$ = $;
Vue.prototype.$store = store;

// import Blob from "./utils/blob";
// import Export2Excel from "./utils/Export2Excel";
// if (process.env.development) {    // 判断是否为mock模式
//     require('./mock/index')
// }
Vue.prototype.echarts = echarts
Vue.use(VueClipBoard);
Vue.use(vcolorpicker)
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | vue-manage-system`;
    const token = localStorage.getItem('token');
    let toPath=to.path
    let fromPath=from.path
    console.log(fromPath)
    let admin =getUserInfo()
    let role
    if (( !token) && to.path !== '/login') {
        next('/login');
    }else if (admin.is_super_admin!==null && admin.is_super_admin===1 ) {
        // 如果是超级管理员
       next()
    }
    else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

var vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
